import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import CompactLayout from 'src/layouts/compact';

// ----------------------------------------------------------------------

const Page404 = lazy(() => import('src/pages/404'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: <Outlet />,
    children: [
      {
        path: '404',
        element: (
          <CompactLayout>
            <Page404 />
          </CompactLayout>
        ),
      },
    ],
  },
];
